
function changeEndAndStartTime(minutes) {
    $(function () {
        $.ajax({
            url: '/superadmin/index',
            type: 'POST',
            data: {
                __RequestVerificationToken: $("[name='__RequestVerificationToken']").val(),
                granularity: minutes
            },
            success: function (response) {
                $("#startAndEndTimeDiv").replaceWith(response);
            },
            error: function (xhr) {
                //alert(xhr.responseText);
            }
        });
    });
}

$('#saturdayTimeSlotWeekendDayInclusion').click(function () {
    var previousValue = parseInt($('#timeSlotWeekendDayInclusion').val(), 10);
    var newValue = 0;
    if ($(this).is(':checked')) {
        newValue = previousValue + 1;
    } else {
        newValue = previousValue - 1;
    }
    $('#timeSlotWeekendDayInclusion').val(newValue);
});


$('#sundayTimeSlotWeekendDayInclusion').click(function () {
    var previousValue = parseInt($('#timeSlotWeekendDayInclusion').val(), 10);
    var newValue = 0;
    if ($(this).is(':checked')) {
        newValue = previousValue + 2;
    } else {
        newValue = previousValue - 2;
    }
    $('#timeSlotWeekendDayInclusion').val(newValue);
});

$(window).on('shown.bs.modal', function () {

    var granularity = $('#granularitySelect').find(":selected").text();
    var startTime = $('#startTimeSelect').find(":selected").text();
    var endTime = $('#endTimeSelect').find(":selected").text();
    var expiration = $('#expirationSelect').find(":selected").text();

    var possibleLang = document.cookie.match(new RegExp('(^| )' + '.AspNetCore.Culture' + '=([^;]+)'));
    var cookie = "EN";
    if (possibleLang != null) {

        cookie = possibleLang[2].match(new RegExp('[a-z]{2}'))[0];
        cookie = cookie.toUpperCase();
    }
    var langId = cookie == "EN" ? 2 : 1;

    $('#granularity').text(granularity);
    var to = " to ";
    var allowed = " allowed to confirm";
    if (langId == 1) {
        to = " à ";
        allowed = " délai de confirmation"
    }
    $("#startAndEndTimes").text(startTime.toUpperCase() + to + endTime.toUpperCase());
    $("#expiration").text(expiration + allowed)

    $("#weekendDays").empty();
    var weekendDaysDefaultLabel = document.createElement("span");
    var weekendDaysSecondLabel = null;
    switch (parseInt($('#timeSlotWeekendDayInclusion').val())) {
        case 0:
            weekendDaysDefaultLabel.innerText = (langId == 1 ? "Ne pas autoriser les jours de fin de semaine" : "Do Not Allow Weekend Days");
            break;
        case 1:
            weekendDaysDefaultLabel.innerText = (langId == 1 ? "Autoriser le samedi" : "Allow Saturday");
            break;
        case 2:
            weekendDaysDefaultLabel.innerText = (langId == 1 ? "Autoriser le dimanche" : "Allow Sunday");
            break;
        case 3:
            weekendDaysSecondLabel = document.createElement("span");
            weekendDaysSecondLabel.innerText = (langId == 1 ? "Autoriser le dimanche" : "Allow Sunday");
            weekendDaysDefaultLabel.innerText = (langId == 1 ? "Autoriser le samedi" : "Allow Saturday");
            break;
        default:
            break;
    }
    $("#weekendDays").append(weekendDaysDefaultLabel);
    if (weekendDaysSecondLabel != null) {
        var space = document.createElement("br");
        $("#weekendDays").append(space);
        $("#weekendDays").append(weekendDaysSecondLabel);
    }
});

function submitGlobalSettings() {

    if ($("#globalSettingsForm").valid()) {

        var data = {
            TimeSlotGranularity: $("#granularitySelect").find(":selected").val(),
            TimeSlotDateStartId: $("#startTimeSelect").find(":selected").val(),
            TimeSlotDateEndId: $("#endTimeSelect").find(":selected").val(),
            TimeSlotReservationExpiration: $("#expirationSelect").find(":selected").val(),
            TimeSlotWeekendDayInclusion: $("#timeSlotWeekendDayInclusion").val()
        }

        $.ajax({
            url: '/api/superadmin/UpdateGlobalSettings',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            success: function (response) {
                window.location = window.location.protocol + "//" + window.location.host + "/superadmin/manage";
            },
            error: function (xhr) {
                //alert(xhr.responseText);
            }
        });
    }
    else {
        $("#confirmModal").modal('hide');
    }
}

$("#startTimeSelect").on("change", function () {
    $(`#endTimeSelect > option`).prop("disabled", false);
    var startTimeSelectOptions = $("#startTimeSelect").find(":selected").val();
    for (var i = startTimeSelectOptions; i > 0; i--) {
        $(`#endTimeSelect > option[value=${i}]`).prop("disabled", true);
        $(`#endTimeSelect > option[value=${i}]`).prop("selected", false);
    }
});